import styled from '@emotion/styled'

export const Label = styled.label<{ scheme: string }>`
  padding-bottom: 10px;
  display: block;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  ${({ scheme }) => scheme ?? ''}
`

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`

export const Textarea = styled.textarea<{ scheme: string }>`
  font-family: inherit;
  resize: none;
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
  border-width: 1px;
  border-style: solid;
  font-weight: bold;
  font-size: 16px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 5px;
  margin-bottom: 12px;
  ${({ scheme }) => scheme ?? ''}
`
